var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rendered)?_c('div',{staticClass:"card mb-2"},[_c('table',{ref:"adhoc",staticClass:"data-table w-100",attrs:{"data-dom":_vm.dom,"data-select":"true","data-action":"/api/report/adhoc"}}),_vm._v(" "),_c('div',{staticClass:"card-footer bg-secondary"})]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d9f9bc5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/reports/adhoc.vue
// module id = FkHT
// module chunks = 0